import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../utils/usePageTitle';
import api from '../services/api';
import './Login.css';

function Login({ onLogin }) {
  usePageTitle('Login');

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setPending(false);
    setLoading(true);

    try {
      await api.login(email, password);
      onLogin();
    } catch (err) {
      const data = err.response?.data || {};
      if (data.pending_approval) {
        setPending(true);
        setError(data.error || 'Your account is pending admin approval.');
      } else {
        setError(data.error || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-icon">🎯</div>
          <h1>Keyword Intelligence</h1>
          <p>Professional SEO Analytics Platform</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? '⏳ Signing in...' : '🔐 Sign In to Platform'}
          </button>

          {error && (
            <div className={pending ? "info-message" : "error-message"}
                 style={pending ? {
                   background: '#fef3c7',
                   border: '1px solid #fde68a',
                   color: '#92400e',
                   padding: '12px 14px',
                   borderRadius: 8,
                   marginTop: 14,
                   fontSize: 13,
                   lineHeight: 1.5,
                 } : undefined}>
              {pending && <strong style={{ display: 'block', marginBottom: 4 }}>⏳ Account pending approval</strong>}
              {error}
              {pending && (
                <div style={{ marginTop: 8, fontSize: 12, color: '#78350f' }}>
                  If you need this expedited, contact{' '}
                  <a href="mailto:parv@paramounttechnetwork.com" style={{ color: '#78350f', fontWeight: 600 }}>
                    parv@paramounttechnetwork.com
                  </a>.
                </div>
              )}
            </div>
          )}
        </form>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #e5e7eb', textAlign: 'center', fontSize: 13, color: '#64748b' }}>
          Need an account?{' '}
          <Link to="/register" style={{ color: '#6366f1', fontWeight: 600, textDecoration: 'none' }}>
            Request access →
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
